import React from 'react';

// --- 1. THIRD-PARTY LIBRARY IMPORTS ---
// Imports removed as they are failing in this environment.
// We will use CDN links via CSS @import instead.
import { Container, Image, Row, Col } from 'react-bootstrap'; 
import { TelephoneFill, Globe } from 'react-bootstrap-icons';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';

// --- 2. LOCAL ASSET (IMAGE) IMPORTS ---
// Mock paths for assets since they are not provided
import msmeLogo from '../assets/msme.png';
import isoLogo from '../assets/iso_logo.png';

// --- 3. LOCAL COMPONENT IMPORTS ---
import Topicspdf from './Topicspdf';
import BenefitsSection from './Benefits';
import HackingToolsPage from './Tools';
import RealTimeProjects from './Projects';
// ... (all other 30+ chapter imports) ...
import Chapter1Page from './chapters/Chapter1';
import ChapterPage from './chapters/Chapter2';
import Chapter3 from './chapters/Chapter3';
import Chapter4 from './chapters/Chapter4';
import Chapter5 from './chapters/Chapter5';
import Chapter6 from './chapters/Chapter6';
import Chapter7 from './chapters/Chapter7';
import Chapter8 from './chapters/Chapter8';
import Chapter9 from './chapters/Chapter9';
import Chapter10 from './chapters/Chapter10';
import Chapter11 from './chapters/Chapter11';
import Chapter12 from './chapters/Chapter12';
import Chapter13 from './chapters/Chapter13';
import Chapter14 from './chapters/Chapter14';
import Chapter15 from './chapters/Chapter15';
import Chapter16 from './chapters/Chapter16';
import Chapter17 from './chapters/Chapter17';
import Chapter18 from './chapters/Chapter18';
import Chapter19 from './chapters/Chapter19';
import Chapter20 from './chapters/Chapter20';
import Chapter21 from './chapters/Chapter21';
import Chapter22Page from './chapters/Chapter22';
import Chapter23 from './chapters/Chapter23';
import Chapter24 from './chapters/Chapter24';
import Chapter25Page from './chapters/Chapter25';
import Chapter26 from './chapters/Chapter26';
import Chapter27 from './chapters/Chapter27';
import Chapter28 from './chapters/Chapter28';
import Chapter29Page from './chapters/Chapter29';
import Chapter30 from './chapters/Chapter30';
import Chapter30_2 from './chapters/Chapter30_2';
import Chapter31 from './chapters/Chapter31';
import Chapter31_2 from './chapters/Chapter31_2';
import Companies from './Companies';
import Placements from './Placements';
import Reviews from './Reviews';
import AboutTrainer from './AboutTrainer';
import Gallery from './Gallery';
import Contact from './Contact';
import MobileStickyRegisterBar from './mobileStickyRegisterBar';

// --- 4. VARIABLE DEFINITIONS ---
// (Must come AFTER all imports)
const lectureHallImg = 'https://skillsuprise.com/data/cyberPDF/homepolice.png';
const logoUrl = 'https://skillsuprise.com/data/cyberPDF/sklogo.png'; 
// Using placeholder.co for missing local assets


// --- 5. INTERNAL CSS STYLES ---
const internalCSS = `
  /* --- CSS FIX: Import Bootstrap and Bootstrap Icons from CDN --- */
  @import url("https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css");
  @import url("https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.css");

  :root {
    --program-blue: #004aad;
    --program-gold: #fec107;
    --program-green: rgba(25, 135, 84, 0.9);
  }

  .course-ad-container {
    max-width: 900px; 
   
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    border: 1px solid #ddd;
    overflow: hidden;
    background-color: #fff;
  }

  /* --- HEADER (DIV-BASED) --- */
  .header-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 30px;
      border-bottom: 1px solid #e0e0e0;
  }
  .header-logo-div img {
      height: 45px;
      width: auto;
      display: block;
  }
  .header-contact-div {
      display: flex;
      flex-direction: column; 
      gap: 8px; 
  }
  .contact-line {
      display: flex;
      align-items: center;
      font-size: 15px;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  }
  .contact-line svg, .contact-line .bi { /* --- CSS FIX: Target .bi icons --- */
      font-size: 24px;
      margin-right: 10px;
      color: #111;
  }
  .contact-line strong {
      color: #000;
      font-weight: 700;
  }
  .contact-line a {
      color: #004a99;
      text-decoration: none;
      font-weight: 700;
      margin-left: 5px;
  }
  .contact-line a:hover {
      text-decoration: underline;
  }

  /* --- Banner Overlay --- */
  .trusted-banner {
    position: absolute;
    bottom: 20px; 
    left: 50%;
    transform: translateX(-50%);
    background-color: var(--program-green);
    color: white;
    padding: 8px 16px;
    border-radius: 20px;
    font-weight: 500;
    font-size: 1rem;
    white-space: nowrap;
    z-index: 10;
  }

  /* --- Blue Details Section --- */
  .program-details {
    background-color: var(--program-blue);
  }
  .program-title {
    font-weight: 700;
    font-size: 2.5rem; 
    line-height: 1.2;
  }
  .stars-wrapper i {
    color: var(--program-gold);
    font-size: 1rem;
    margin-right: 2px;
  }
  .rating-text {
    font-size: 1.1rem;
    font-weight: 500;
  }

  /* --- Batch Info --- */
  .batch-info {
    font-size: 1rem;
    font-weight: 500;
  }
  .batch-label {
    font-weight: 700;
    color: var(--program-gold); 
    
  }

  /* --- Footer --- */
  .footer-logo {
    height: 55px;
    width: auto;
    object-fit: contain;
  }
  .address-line {
    font-size: 0.75rem;
    color: #333;
  }

  /* --- ########## RESPONSIVE STYLES ########## --- */
  
  /* Header Mobile */
  @media (max-width: 600px) {
      .header-container {
          gap: 10px; 
          padding: 15px; 
      }
      .header-logo-div img {
          height: 25px; /* <-- CSS FIX: Adjusted size */
      }
      .header-contact-div {
          align-items: flex-start; 
          gap: 4px; 
      }
      .contact-line {
          font-size: 11px; 
      }
      .contact-line svg, .contact-line .bi { /* --- CSS FIX: Target .bi icons --- */
          font-size: 18px; 
          margin-right: 5px; 
      }
  }

  /* Page Content Mobile */
  @media (max-width: 767.98px) {
    .program-title {
      font-size: 1.2rem;
    }
    .trusted-banner {
      font-size: 0.8rem;
      padding: 6px 12px;
      bottom: 10px;
      width: 62%; 
      text-align: center;
      white-space: normal;
    }
    .batch-info {
      font-size: 0.6rem;
    }
    
    /* <-- CSS FIX: Added back mobile border rule */
    /* --- JSX FIX: Converted to Bootstrap classes, so this rule is adjusted --- */
    .batch-info .row.mb-3 {
      
      padding-bottom: 1rem;
      margin-bottom: 1rem !important;
    }
    .batch-info .row.gy-2:last-child {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }
   
    /* --- FOOTER RESPONSIVE FIXES --- */

    /* <-- CSS FIX: Removed the rule that forced text-center !important */
    /*
    .footer-details .col-12,
    .footer-details .col-md-8 {
      text-align: center !important; 
    }
    */

    /* <-- CSS FIX: Added rules to shrink logos and text for mobile layout */
    .footer-logo {
      height: 30px; /* Smaller logos on mobile */
    }
    .address-line {
      font-size: 0.5rem; /* Smaller address text on mobile */
      line-height: 1.3; /* Tighter line height */
    }
    .footer-details .row {
      align-items: center; /* Ensure vertical centering */
    }
  }
`;

// --- 6. COMPONENT DEFINITION ---
const CyberBootcampPdf = () => {
  return (
    <>
      <style>{internalCSS}</style>

      {/* Main container wraps the entire page */}
      <div className="course-ad-container">

        {/* 1. Header (NEW div-based header) */}
        <div className="header-container">
          <div className="header-logo-div">
            <img src={logoUrl} alt="Skills Uprise Logo" />
          </div>
          <div className="header-contact-div">
            <div className="contact-line">
              {/* --- JSX FIX: Replaced component with <i> tag --- */}
              <i className="bi bi-telephone-fill"></i> 
           
              <a href="tel:9490174876">9490174876</a>
            </div>
            <div className="contact-line">
              {/* --- JSX FIX: Replaced component with <i> tag --- */}
              <i className="bi bi-globe"></i> 

              <a href="https://www.skillsuprise.com" target="_blank" rel="noopener noreferrer">www.skillsuprise.com</a>
            </div>
          </div>
        </div>

        {/* 2. Top Image (Classroom) */}
        <div className="position-relative">
          {/* --- JSX FIX: Replaced <Image> with <img> --- */}
          <img 
            src={lectureHallImg} 
            alt="Students in ethical hacking lecture" 
            className="w-100" 
            onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/900x300/cccccc/000000?text=Lecture+Image'; }}
          />
        </div>

       

        {/* 4. Main Details Section (Blue) */}
        <div className="program-details text-white p-3 p-md-5">
          {/* --- JSX FIX: Replaced <Container> with <div> --- */}
          <div className="container-fluid"> 
            <h1 className="program-title mb-3">
              Ethical Hacking & Cyber Security Training & Internship Program
            </h1>
            
            <div className="d-flex align-items: center mb-4">
              <div className="stars-wrapper me-2">
                {/* These icons will now work thanks to the CSS @import */}
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
              <span className="rating-text">( 4.8 ) 20,000+ Ratings</span>
            </div>

            {/* Batch Info Grid */}
            <div className="batch-info">
              {/* --- JSX FIX: Replaced <Row> and <Col> with <div> and Bootstrap classes --- */}
              <div className="row d-flex mb-2 gy-2"> 
                <div className="col-5 mb-1 col-md-5">
                  <span className="batch-label">Batch 1 Starts :</span> 15th Dec
                </div>
                <div className="col-7 col-md-7">
                  <span className="batch-label">Batch 1 Registration Ends :</span> 13th Dec
                </div>
              </div>
              <div className="row d-flex mb-2 gy-2">
                <div className="col-5 mb-1 col-md-5">
                  <span className="batch-label">Batch 2 Starts :</span> 15th Feb
                </div>
                 <div className="col-7 col-md-7">
                  <span className="batch-label">Batch 2 Registration Ends :</span> 13th Feb
                </div>
              </div>
              <div className="row d-flex mb-2 gy-2">
                 <div className="col-5 mb-1 col-md-5">
                  <span className="batch-label">Batch 3 Starts :</span> 07th April
                </div>
                 <div className="col-7 col-md-7">
                  <span className="batch-label">Batch 3 Registration Ends :</span> 5th April
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 5. Footer Section */}
        <div className="footer-details bg-white">
          {/* --- JSX FIX: Replaced <Container> with <div> --- */}
          <div className="container-fluid">
            {/* --- JSX FIXES ---
              1. Replaced <Row> and <Col> with <div> and Bootstrap classes
              2. Kept the `col-6` class to force side-by-side layout on mobile.
              3. Replaced <Image> with <img>
            */}
            <div className="row gy-3 pb-2 d-flex align-items-center">
              <div className="col-6 col-md-4 d-flex justify-content-center justify-content-md-between">
                <img src={msmeLogo} alt="MSME Govt of India" className="footer-logo me-3" />
                <img src={isoLogo} alt="ISO Certified" className="footer-logo" />
              </div>
              
              <div className="col-6 col-md-8 text-start text-md-end">
                <p className="address-line mb-0">
                  <strong>Address :</strong> Beside Medicover Hospitals
                </p>
                <p className="address-line mb-0">
                  MVP Colony, Visakhapatnam, 530017
                </p>
              </div>
            </div>
          </div>
        </div>

    
      </div>
       <Topicspdf/>
        <BenefitsSection/>
        <HackingToolsPage/>
        <RealTimeProjects/>
        <Chapter1Page/>
        <ChapterPage/>
        <Chapter3/>
        <Chapter4/>
        <Chapter5/>
        <Chapter6/>
        <Chapter7/>
        <Chapter8/>
        <Chapter9/>
        <Chapter10/>
        <Chapter11/>
        <Chapter12/>
        <Chapter13/>
        <Chapter14/>
        <Chapter15/>
        <Chapter16/>
        <Chapter17/>
        <Chapter18/>
        <Chapter19/>
        <Chapter20/>
        <Chapter21/>
        <Chapter22Page/>
        <Chapter23/>
        <Chapter24/>
        <Chapter25Page/>
        <Chapter26/>
        <Chapter27/>
        <Chapter28/>
        <Chapter29Page/>
        <Chapter30/>
        <Chapter30_2/>
        <Chapter31/>
        <Chapter31_2/>
        <Companies/>
        <Placements/>
        <Reviews/>
        <AboutTrainer/>
        <Gallery/>
        <Contact/>
<MobileStickyRegisterBar/>
    </>
  );
};

export default CyberBootcampPdf;

